import { useQuery } from "@tanstack/react-query";

import { getCategories } from "../../api/catalog";

/** useCategories — видимые разделы витрины (docs/07-miniapp-ux.md §3: staleTime 30с для каталога). */
export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: ({ signal }) => getCategories(signal),
    staleTime: 30_000,
  });
}
